// extracted by mini-css-extract-plugin
export default {"wrapper":"FixedPriceFields_wrapper__qHDuY"};